var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-pane",attrs:{"id":"allTab","aria-labelledby":"all-tab","role":"tabpanel"}},[_c('SalaryTab'),_c('OtherContractsTab'),_c('SabbaticalsTab'),(_vm.loggedUser.roles.includes('super-admin'))?_c('TracesTab'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }